import React, { useState } from 'react'
import { FaCheck } from 'react-icons/fa'
import { Form, Formik, Field, useField } from 'formik'
import * as yup from 'yup'
import emailjs from 'emailjs-com'
import './TextField.css'

const schema = yup.object({
  name: yup.string().required().max(22).min(3),
  Email: yup.string().email().required(),
  message: yup.string().required()
})

const ErrorText = ({errorMessage, className, sent}) => {
  return(
      <div className={`error-text ${className}`}>
        {sent && <FaCheck className="message-sent-icon" />}
        {errorMessage}
      </div>
    )
}

const MyTextField = ({placeholder, errorMessage, textarea, type, messageSent, ...props}) => {
    const [field, meta] = useField(props)
    const errorText = meta.error && meta.touched ? meta.error : ""
    return (
      <>
         {
         textarea ?
         <div className="input">
             <textarea
              rows="3"
              type={type}
              placeholder={placeholder}
              {...field}
              />
              {messageSent && <ErrorText className="message-sent" errorMessage="Message Sent" sent />}
         </div>
         :
         <div className="input">
             <input
              type={type}
              placeholder={placeholder}
              {...field}
              />
             <ErrorText errorMessage={errorText} />
         </div>
         }
      </>
  )
  }

const Submitting = (data) => {
  const templateId = 'template_ugnokci';
  const userId = 'user_spT0gesNImN6sDQ9pUGBm';
  sendMessage(templateId, userId, data)
  }

  const sendMessage = (templateId, userId, variables) => {
    emailjs.send(
        'service_ykd0m2u', 
        templateId,
        variables,
        userId
    ).then(res => {
      console.log()
    })
    .catch(err => console.error(err))
  }

const SendMsgForm = () => {
  const [messageSent, setMessageSent] = useState(false)
    return (
        <Formik validationSchema={schema} initialValues={{name:"", Email:"", message:""}} onSubmit={
          (data, {setSubmitting, resetForm}) => {
             setSubmitting(true)
             Submitting(data)
             resetForm()
             setMessageSent(true)
             setTimeout(function() {
              setMessageSent(false)
             }, 2000)
          }
      }
        >
            {({isSubmitting}) => {
                return(
                    <Form>
                        <Field placeholder="Full Name" name="name" type="text" as={MyTextField} />
                        <Field placeholder="Email Address" name="Email" type="text" as={MyTextField} />
                        <Field placeholder="Message" name="message" type="text" messageSent={messageSent} textarea as={MyTextField} />
                        <input disabled={isSubmitting} type="submit" className={`active-submit ${isSubmitting ? 'disabled' : ''}`} />
                    </Form>
                  )
            }}
        </Formik>
    )
}

export default SendMsgForm
